'use strict';

var stringUnderscore = require('./stringUnderscore');

function stringSpacify(str) {
  return stringUnderscore(str).replace(/_/g, ' ');
}

module.exports = stringSpacify;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/string/internal/stringSpacify.js
// module id = 325
// module chunks = 0